import { cx } from '@emotion/css';
import { ReactNode } from 'react';

import {
  contentCardClassName,
  innerClassName,
  noBorderClassName,
  noPaddingClassName,
  noSpacingClassName,
} from './styles';

interface Props {
  children: ReactNode;
  className?: string;
  noBorder?: boolean;
  noPadding?: boolean;
  noSpacing?: boolean;
}

const ContentCard = ({
  children,
  className = '',
  noBorder,
  noPadding,
  noSpacing,
}: Props) => {
  return (
    <div
      className={cx(contentCardClassName, {
        [noBorderClassName]: noBorder,
        [noSpacingClassName]: noSpacing,
        [className]: !!className,
      })}
    >
      <div className={cx(innerClassName, { [noPaddingClassName]: noPadding })}>
        {children}
      </div>
    </div>
  );
};

ContentCard.displayName = 'ContentCard';

export default ContentCard;
